import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuyNowButtonComponent } from "../../components/buy-now-button/buy-now-button.component";
import { GalleryComponent } from '../../components/gallery/gallery.component';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [
    CommonModule,
    BuyNowButtonComponent,
    GalleryComponent
  ],
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent {
  benefits = [
    {
      title: 'More affordable than conventional medicine',
      icon: 'money'
    },
    {
      title: 'Easier to obtain than prescription medicine',
      icon: 'pharmacy'
    },
    {
      title: 'Stabilizes hormones and your metabolism',
      icon: 'balance'
    },
    {
      title: 'Natural healing and fewer adverse effects',
      icon: 'leaf'
    },
    {
      title: 'Strengthens your immune system naturally',
      icon: 'shield'
    }
  ];
}
